export default {
  subtitle: 'We POST the selected events to your endpoints, signed with the endpoint secret.',
  regenerate_confirm: 'Generate a new signing secret? The current secret stops working immediately.',
  delete_confirm: 'Delete this endpoint? It will stop receiving events.',
  consecutive_failures: '{{count}} consecutive failures',
  columns: {
    url: 'Endpoint',
    events: 'Events',
    status: 'Status',
    secret: 'Secret',
  },
  statuses: {
    active: 'Active',
    disabled: 'Disabled',
    auto_disabled: 'Auto-disabled',
  },
  buttons: {
    create: 'Add endpoint',
    edit: 'Edit',
    regenerate_secret: 'New secret',
    delete: 'Delete',
  },
  toasts: {
    load_error: 'Could not load the webhook endpoints.',
    error: 'Something went wrong. Please try again.',
    deleted: 'Endpoint deleted.',
  },
};
